import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { sortBy } from '@features/arrays/sort-by';
import { IconSize } from '@features/icons/icon-size';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Collection } from '../collection';
import { CollectionService } from '../collection.service';

@Component({
  selector: 'app-user-collection-selector',
  templateUrl: './user-collection-selector.component.html',
  styleUrls: ['./user-collection-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserCollectionSelectorComponent implements AfterViewChecked {
  isCreateMode = false;

  @Input() iconSize: IconSize = IconSize.Large;

  @ViewChild(NgbDropdown) dropdown: NgbDropdown;

  createInputControl: FormControl = new FormControl();

  @ViewChild('createCollectionNameField')
  input: ElementRef;

  sortedList$: Observable<Collection[]> = this.collectionService.state$.pipe(
    map((state) => sortBy(state.listOfCollections, 'name')),
  );

  constructor(public collectionService: CollectionService) {}

  ngAfterViewChecked() {
    if (this.isCreateMode && this.input && this.input.nativeElement) {
      this.input.nativeElement.focus();
    }
  }

  setCreateMode() {
    this.isCreateMode = true;
  }

  keydown(event: KeyboardEvent) {
    switch (event.key) {
      case 'Enter':
        this.createCollection();
        break;
      case 'Escape':
        this.isCreateMode = false;
        break;
      default:
    }
  }

  closeDropdown() {
    this.dropdown.close();
  }

  openChange(isDropdownOpen: boolean) {
    if (!isDropdownOpen) this.isCreateMode = false;
  }

  getName(): string {
    let name: string = (this.createInputControl.value || '').trim();
    if (name.length === 0) {
      name = 'My collection';
    }

    return name;
  }

  createCollection(): Observable<Collection> {
    this.isCreateMode = false;
    const name = this.getName();
    this.createInputControl.reset();

    return this.collectionService.createCollection(
      new Collection({ name }),
      true,
    );
  }
}
